import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  surveyList(code: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/Survey/GetSurveyListByApplicationCode/${code}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getQuestionDetail(id: string): Observable<any> {
    let url = `${environment.apiLocations.survey}/Question/${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  createSurvey(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.survey}/Survey`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteQuestion(id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiLocations.survey}/Question/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  addQuestion(id: string, data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.survey}/Question/${id}`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  updateQuestion(id: string, data: any): Observable<any> {
    return this.http.put<any>(
      `${environment.apiLocations.survey}/Question/${id}`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
